export default __webpack_public_path__ + "static/media/p2p-banners-ms.dad487eb.webp";